module.exports = __webpack_public_path__ + "img/tools.5c72e832.svg";